/* eslint no-unused-vars: 0 */

import CssContext from "../misc/csscontext";
import ProductPage from "../controllers/product";

const productPage = new ProductPage(
  window.ProductPageAddToCartUrl,
  window.ProductPageGetLinkCartUrl,
  window.ProductPageCartLockedUrl,
  window.ChangeProductQuantityUrl,
  window.floatingCartUrl
);

$(() => {
  $("#quantity-select select").on("change", () => {
    $("#quantity").val($(this).val());
  });

  if (window.HasProductPromotions) {
    const context = CssContext.getContext();
    if (context !== "bp0") {
      $(".product-promos-wrapper").show();
      $("img.lazy").lazyload({ container: $(".product-promos") });
    } else {
      $(".product-promos-wrapper").remove();
    }
  }
});